import { Column, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Produit } from './produit.entity';
import ActiviteEntente from './activite-entente.entity';
import Facturation from './facturation.entity';
import { NombreLog } from './nombre-log.entity';
import { HistoriquePrixProduit } from './historique-prix-produit.entity';

@Entity('activite_entente_produit')
export default class ActiviteEntenteProduit {
    static key = 'activite-entente-produit';

    name: ''; // Pour le formulaire de création d'entité

    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    fk_id_produit: number;

    @ManyToOne(() => Produit)
    @JoinColumn({ name: 'fk_id_produit', referencedColumnName: 'id' })
    produit: Produit;

    @Column({ nullable: true })
    fk_id_activite_entente: number;

    @ManyToOne(() => ActiviteEntente)
    @JoinColumn({ name: 'fk_id_activite_entente', referencedColumnName: 'id' })
    activiteEntente: ActiviteEntente;

    @Column({ type: 'integer', nullable: true })
    priorite: number | '';

    @Column({ nullable: true })
    fk_id_facturation: number;

    @OneToOne(() => Facturation, { cascade: true })
    @JoinColumn({ name: 'fk_id_facturation', referencedColumnName: 'id' })
    facturation: Facturation;

    @OneToMany(() => NombreLog, (nombreLog: NombreLog) => nombreLog.activiteEntenteProduit, { cascade: true })
    nombreLogs: NombreLog[];

    @Column({ nullable: true })
    fk_id_historique_prix_produit: number;

    @ManyToOne(() => HistoriquePrixProduit)
    @JoinColumn({ name: 'fk_id_historique_prix_produit', referencedColumnName: 'id' })
    historique_prix_produit: HistoriquePrixProduit;

    @Column({ nullable: true })
    note_fournisseur_invisible: boolean;

    @Column({ nullable: true })
    note_client_invisible: boolean;

    @Column({ nullable: true })
    note_interne_invisible: boolean;
}
